import { Directive, Host, EventEmitter, Output, OnInit, OnDestroy } from '@angular/core';
import { CellClickEvent, GridComponent } from '@progress/kendo-angular-grid';
import { Subscription } from 'rxjs';
import { Preventable } from '@technocom/common/platform';

@Directive({
  selector: '[appGridCellDblClick]',
})
export class GridCellDblClickDirective implements OnInit, OnDestroy {
  constructor(@Host() private grid: GridComponent) {
    this.onCellClick = this.onCellClick.bind(this);
  }

  @Output() cellDblClick: EventEmitter<CellClickEvent> = new EventEmitter();

  private subscription = new Subscription();

  ngOnInit() {
    this.subscription.add(this.grid.cellClick.subscribe(this.onCellClick));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private onCellClick(e: CellClickEvent) {
    const trigger = e.originalEvent as MouseEvent & Preventable;
    if (e.type === 'click') {
      const double = trigger.detail > 0 && trigger.detail % 2 === 0;
      if (double) {
        this.cellDblClick.emit(e);
      }
    }
  }
}
